import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Loader, ImpersonationBanner } from "./components";
import { RoutesHandler } from "./routes";
import { Maintenance } from "./containers";
import { setCookie } from "./utils";
import { useAuth, useUser } from "./context/hooks";
import i18next from "./i18n";

function App() {
  const { userId, isAuthenticated, authCheckState } = useAuth();
  const { user, isResetPassword, getUser } = useUser();
  const [bootstrapping, setBootstrapping] = useState(true);
  const [hasFetchedUser, setHasFetchedUser] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const isInvitation = searchParams.get("redirectURL");
  const isMessage = searchParams.get("materialId");
  const multipleOrderId = searchParams.get("multipleOrderId");

  useEffect(() => {
    let isMounted = true;
    const bootstrap = async () => {
      await authCheckState();
      if (userId) {
        await getUser();
        setHasFetchedUser(true);
      }
      if (isMounted) setBootstrapping(false);
    };
    bootstrap();
    return () => {
      isMounted = false;
    };
  }, [userId, authCheckState, getUser]);

  useEffect(() => {
    if (!bootstrapping && isAuthenticated && hasFetchedUser) {
      if (isInvitation) {
        const redirectUrl = isInvitation;
        const params = new URLSearchParams();
        if (multipleOrderId) params.set("multipleOrderId", multipleOrderId);
        if (isMessage) params.set("materialId", isMessage);
        const queryString = params.toString();
        navigate(queryString ? `${redirectUrl}?${queryString}` : redirectUrl);
      }
    }
  }, [
    bootstrapping,
    isAuthenticated,
    hasFetchedUser,
    isInvitation,
    isMessage,
    multipleOrderId,
    navigate,
  ]);

  useEffect(() => {
    if (user && user.localization) {
      const language = user.localization;
      setCookie("i18nextLng", language, 30);
      localStorage.setItem("i18nextLng", language);
      i18next.changeLanguage(language);
    }
  }, [user]);

  useEffect(() => {
    if (isResetPassword && location.pathname !== "/profile") {
      navigate("/profile");
    }
  }, [isResetPassword, location.pathname, navigate]);

  if (process.env.REACT_APP_MAINTENANCE === "true") {
    return <Maintenance />;
  }

  if (bootstrapping) {
    return <Loader isFullScreen />;
  }

  return (
    <div className="App">
      <ImpersonationBanner />
      <RoutesHandler />
    </div>
  );
}

export default App;
